// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__icon___hNiIb {
  position: relative;
  top: 1px;
}
`, "",{"version":3,"sources":["webpack://./src/components/components/Cart/Unit/styles.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,QAAA;AACF","sourcesContent":[".icon {\n  position: relative;\n  top: 1px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `styles__icon___hNiIb`
};
export default ___CSS_LOADER_EXPORT___;
